export default "__VITE_ASSET__Du56E9HU__"